import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Select from "react-select";
import {
  accountOptions,
  BACKGROUND_COLOR_DARK,
  bankOptions,
  getCustomSelectTagStyles,
} from "../../constants";

const FillBankDetailsModal = ({
  isBankDetailsModalOpen,
  closeBankDetailsModal,
  setFormValues,
  formValues,
  handleFormSubmit,
  handleBankDetailsModalCancel,
}) => {
  const [showAccountNumber, setShowAccountNumber] = useState(false); // Eye toggle state

  // Custom styles for options

  return (
    <Modal
      isOpen={isBankDetailsModalOpen}
      onClose={closeBankDetailsModal}
      isCentered
      size={"sm"}
    >
      <ModalOverlay />
      <ModalContent borderRadius={"20px"} py={3} px={1}>
        <ModalHeader>Bank Details</ModalHeader>
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>Select Bank</FormLabel>
            <Select
              placeholder="Select Bank"
              autoFocus
              options={bankOptions}
              styles={getCustomSelectTagStyles()}
              isSearchable
              onChange={(option) =>
                setFormValues({ ...formValues, bankName: option.value })
              }
            />
          </FormControl>
          <FormControl mt={6} isRequired>
            <FormLabel>Account Number</FormLabel>
            <InputGroup>
              <Input
                type={showAccountNumber ? "text" : "password"} // Toggle input type
                placeholder="Enter Account Number"
                focusBorderColor={BACKGROUND_COLOR_DARK}
                _hover={{ borderColor: BACKGROUND_COLOR_DARK }}
                fontSize={"1.1rem"}
                borderColor={"#ddd"}
                borderRadius={"10px"}
                size="lg"
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    accountNumber: e.target.value,
                  });
                }}
              />
              <InputRightElement>
                <IconButton
                  icon={showAccountNumber ? <ViewOffIcon /> : <ViewIcon />}
                  onClick={() => setShowAccountNumber(!showAccountNumber)} // Toggle icon
                  variant="unstyled"
                  aria-label="Toggle Account Number Visibility"
                  size="lg"
                  marginY={"auto"}
                />
              </InputRightElement>
            </InputGroup>
          </FormControl>
          <FormControl mt={6} isRequired>
            <FormLabel>Account Type</FormLabel>
            <Select
              placeholder="Account Type"
              options={accountOptions}
              styles={getCustomSelectTagStyles()}
              isSearchable
              onChange={(option) =>
                setFormValues({ ...formValues, accountType: option.value })
              }
            />
          </FormControl>
        </ModalBody>
        <ModalFooter
          display={"flex"}
          flexDirection={"column"}
          rowGap={4}
          alignItems={"center"}
          mt={2}
        >
          <Button
            width={"100%"}
            colorScheme="teal"
            onClick={() => {
              handleFormSubmit();
            }}
          >
            Upload
          </Button>
          <Button
            width={"100%"}
            onClick={handleBankDetailsModalCancel}
            variant={"outline"}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FillBankDetailsModal;
